export default __webpack_public_path__ + "static/media/ic_settings_24.25d2f4a7.svg";